<template>
    <form
        class="bg-white flex-grow px-3 md:px-8 py-3"
        @submit.prevent="onSubmit"
    >
        <div class="home-intro-search-grid">
            <div class="home-intro-search-product-cell">
                <div class="font-bold text-f4">Product</div>
                <div class="input-text bg-white">
                    <input
                        class="input-text-input input-text-input-small !bg-white"
                        id="q"
                        type="text"
                        name="q"
                        autofocus
                        :placeholder="searchPlaceholder"
                        v-model="searchTerm"
                        @input="onInput"
                    />
                    <div
                        v-if="
                            !preventDropdownReopen &&
                            showSuggestions &&
                            suggestions.length
                        "
                        v-click-outside="hideSuggestions"
                        class="absolute bg-white shadow rounded mt-2 w-full z-10 p-4"
                    >
                        <ul class="scroll-bar max-h-80" @scroll="onScroll">
                            <li
                                v-for="(suggestion, index) in suggestions"
                                :key="index"
                                class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                @click="selectSuggestion(suggestion)"
                            >
                                {{ suggestion }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <input class="btn-search-black" type="submit" value="" />
        </div>
    </form>
</template>

<script>
import { vClickOutside } from "../../directives/v-click-outside";

import { SearchDriver } from "@elastic/search-ui";
import config from "../../searchConfig";

const driver = new SearchDriver(config);

export default {
    props: {
        searchTitle: {
            type: String,
            default: "Find the items you want from our range",
        },
        searchPlaceholder: {
            type: String,
            default: "Product name, Item number, …",
        },
    },
    directives: {
        clickOutside: vClickOutside,
    },
    inject: ["overlaysSvc", "cartSvc"],
    data() {
        return {
            searchState: {},
            searchTerm: "",
            showSuggestions: false,
            preventDropdownReopen: false,
            isLoggedIn: this.cartSvc.isUserLoggedIn(),
            suggestions: [],
            resultsPerPage: 20,
            currentResults: 20,
            sortBy: "Artikelnr",
        };
    },
    mounted() {
        const { searchTerm, sortField, resultsPerPage, filters, facets } =
            driver.getState();

        this.sortBy = sortField;
        this.resultsPerPage = resultsPerPage;
        filters.forEach((filter) => {
            if (
                facets[filter.field] &&
                facets[filter.field].length > 0 &&
                facets[filter.field][0].type === "range"
            ) {
                this[filter.field] = filter.values.map((value) => value.name);
            } else {
                this[filter.field] = filter.values;
            }
        });

        driver.subscribeToStateChanges((state) => {
            this.searchState = state;
        });

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
    },
    watch: {
        suggestions(newSuggestions) {
            if (!this.preventDropdownReopen) {
                this.showSuggestions = newSuggestions.length > 0;
            }
        },
        modelValue(newValue) {
            this.searchTerm = newValue;
        },
    },
    methods: {
        onInput(event) {
            this.preventDropdownReopen = false;

            this.fetchAutocompleteSuggestions(this.searchTerm);
        },
        selectSuggestion(suggestion) {
            this.searchTerm = suggestion;
            this.showSuggestions = false;
            this.preventDropdownReopen = true; // Prevent reopening until the user types again

            // redirect to /shop with q as query parameter
            const url = new URL("/shop", window.location.origin);
            url.searchParams.set("q", suggestion);

            window.location.replace(url.toString());
        },
        hideSuggestions() {
            this.showSuggestions = false;
        },
        onSubmit(event) {
            this.showSuggestions = false;
            this.preventDropdownReopen = true;

            const url = new URL("/shop", window.location.origin);
            url.searchParams.set("q", this.searchTerm);

            window.location.replace(url.toString());
        },
        onScroll(event) {
            const { scrollTop, scrollHeight, clientHeight } = event.target;
            if (scrollTop + clientHeight >= scrollHeight) {
                this.fetchMoreAutocompleteSuggestions(this.searchTerm);
            }
        },

        fetchAutocompleteSuggestions(searchTerm) {
            if (!searchTerm) {
                this.suggestions = [];
                return;
            }

            driver.getActions().setSearchTerm(searchTerm, {
                refresh: false,
                autocompleteResults: true,
            });

            driver.subscribeToStateChanges((state) => {
                if (state.autocompletedResults) {
                    this.suggestions = state.autocompletedResults.map(
                        (result) => result.Artikelbeschreibung.raw, // Adjust field name based on your schema
                    );
                }
            });
        },
        fetchMoreAutocompleteSuggestions(searchTerm) {
            if (!searchTerm) {
                this.suggestions = [];
                return;
            }

            const additionalSuggestionsCount = 10;
            const newResultsPerPage =
                this.suggestions.length + additionalSuggestionsCount;

            // Direct API call to fetch more autocomplete results
            fetch(`/actions/search/elastic/autocomplete`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    state: {
                        searchTerm: searchTerm,
                    },
                    queryConfig: {
                        results: {
                            resultsPerPage: newResultsPerPage,
                        },
                    },
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    this.suggestions = data.autocompletedResults.map(
                        (result) => result.Artikelbeschreibung.raw, // Adjust field name based on your schema
                    );
                })
                .catch((error) => {
                    console.error(
                        "Error fetching more autocomplete suggestions:",
                        error,
                    );
                });
        },
    },
};
</script>
